import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import TimelineTimelineDesktop from './TimelineTimelineDesktop';
import TimelineTimelineMobile from './TimelineTimelineMobile';
import { COLOURS } from './Timeline._constants';
import { media, SCREEN_WIDTH } from '../../utils/media';
import { useMobile } from './Timeline._helpers';
const ContainerDotted = styled.div `
  display: flex;
  align-items: center;
  height: calc(100vh - 74px);
  padding-left: 11px;

  ${media.tablet} {
    height: ${({ containerHeight }) => (containerHeight ? containerHeight + `px` : `0px`)};
  }

  // border, inset
  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: -5px;
    left: 17px;
    width: 2px;
    z-index: -1;
    background-image: linear-gradient(to top, ${COLOURS.WHITE_10} 80%, ${COLOURS.GREY_10} 20%);
    background-size: 2px 10px;
    background-position: top;
  }
`;
const ContainerDottedMobile = styled.div `
  z-index: 9;
  position: relative;

  // border, inset
  &:before {
    content: '';
    position: absolute;
    bottom: 14px;
    ${(props) => `width: ${props.contentWidth}px;`}
    height: 2px;
    background-image: linear-gradient(to right, ${COLOURS.WHITE_10} 80%, ${COLOURS.GREY_10} 20%);
    background-size: 6px 4px;
    background-position: top;
  }
`;
const TimelineTimeline = (props) => {
    const { setWidth } = props;
    const [isMobile, setIsMobile] = useState(false);
    const [hasIsMobileBeenSet, setHasIsMobileBeenSet] = useState(false);
    const [contentWidth, setContentWidth] = useState(0);
    const [hasContentWidthBeenSet, setHasContentWidthBeenSet] = useState(false);
    useEffect(() => {
        // timeline is repositioned via grid, and has separate components to make layout easier
        // on initial page load, setWidth is 0
        // once the page has rendered than an actual width is captured
        // the below code is a hack to capture the setWidth when mobile and store it in a state variable
        // we want to capture it because when clicking the NavLink associated with a timeline component
        // the screen width temporarily changes to a full screen width which we do not want
        if (setWidth !== 0 && !hasIsMobileBeenSet) {
            const isWindowCurrentlyMobile = useMobile(props.setWidth, SCREEN_WIDTH.MOBILE) || false;
            setIsMobile(isWindowCurrentlyMobile);
            setHasIsMobileBeenSet(true);
        }
    }, [setWidth]);
    useEffect(() => {
        if (isMobile && setWidth !== 0 && !hasContentWidthBeenSet) {
            setHasContentWidthBeenSet(true);
            setContentWidth(setWidth);
        }
    }, [isMobile, setWidth]);
    const updatedProps = Object.assign(Object.assign({}, props), { contentWidth });
    return (React.createElement(React.Fragment, null,
        !isMobile && (React.createElement(ContainerDotted, { containerHeight: props.containerHeight },
            React.createElement(TimelineTimelineDesktop, Object.assign({}, props)))),
        isMobile && (React.createElement(ContainerDottedMobile, { contentWidth: contentWidth },
            React.createElement(TimelineTimelineMobile, Object.assign({}, updatedProps))))));
};
export default TimelineTimeline;
